import axios from 'axios';

// CHANGE BASE URL
const httpService = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  /*headers: {
    'Authorization': 'Bearer ' + window.localStorage.getItem("jwt")
  }*/
});

export default httpService;